import {
  Box,
  Button,
  Paper,
  Typography,
  Container,
  Grid,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

import EmailIcon from "@mui/icons-material/Email";

const PasswordResetPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f0f4f8 0%, #e6eaf0 100%)",
        padding: 2,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={10}
          sx={{
            width: "100%",
            maxWidth: "500px",
            borderRadius: theme.spacing(3),
            padding: theme.spacing(4),
            background: "linear-gradient(145deg, #f0f4f8 0%, #e6eaf0 100%)",
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
            position: "relative",
            overflow: "hidden",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.02)",
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "-50px",
              left: "-50px",
              width: "150px",
              height: "150px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #00bb00 0%, #00bb00 100%)",
              opacity: 0.1,
            }}
          />

          <Box
            sx={{
              textAlign: "center",
              marginBottom: theme.spacing(3),
              position: "relative",
              zIndex: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 3,
              }}
            >
              <CheckCircleOutlineIcon
                sx={{
                  fontSize: "6rem",
                  color: "#00bb00",
                  background: "rgba(0, 187, 0, 0.1)",
                  borderRadius: "50%",
                  padding: 1,
                  boxShadow: "0 4px 15px rgba(0, 187, 0, 0.2)",
                }}
              />
            </Box>

            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                marginBottom: 2,
              }}
            >
              Password Reset Link Sent!
            </Typography>

            <Typography
              variant="body1"
              color="textSecondary"
              sx={{
                marginBottom: 3,
                lineHeight: 1.6,
              }}
            >
              We have sent a password reset link to your email address. Please
              check your inbox and follow the instructions to reset your
              password.
            </Typography>

            <Grid
              container
              spacing={2}
              sx={{
                justifyContent: "center",
                flexDirection: isMobile ? "column" : "row",
              }}
            >
              {/* <Grid item xs={12} sm={5}>
                <Button
                  variant="contained"
                  fullWidth
                  href="/login"
                  startIcon={<LoginIcon />}
                  sx={{
                    borderRadius: theme.spacing(2),
                    padding: theme.spacing(1.5),
                    background:
                      "linear-gradient(45deg, #00bb00 0%, #00bb00 100%)",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s ease",
                    textTransform: "none",
                    "&:hover": {
                      transform: "scale(1.02)",
                      boxShadow: "0 6px 8px rgba(0,0,0,0.15)",
                    },
                  }}
                >
                  Go to Login
                </Button>
              </Grid> */}
              <Grid item xs={12} sm={5}>
                <Button
                  variant="outlined"
                  fullWidth
                  href="/resend-reset-link"
                  startIcon={<EmailIcon />}
                  sx={{
                    borderRadius: theme.spacing(2),
                    padding: theme.spacing(1.5),
                    textTransform: "none",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      backgroundColor: "rgba(0, 187, 0, 0.05)",
                    },
                  }}
                >
                  Resend Link
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default PasswordResetPage;
